"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toggle = function Toggle(_ref) {
  var name = _ref.name,
      options = _ref.options,
      errors = _ref.errors,
      isInvalid = _ref.isInvalid,
      value = _ref.value,
      type = _ref.type,
      onChange = _ref.onChange,
      className = _ref.className,
      label = _ref.label;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "toggle"
  }, label && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, label), options && /*#__PURE__*/_react.default.createElement(_reactBootstrap.ToggleButtonGroup, {
    type: type,
    value: value,
    name: name,
    className: className,
    onChange: onChange
  }, options.map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.ToggleButton, {
      key: "id ".concat(option.label, " ").concat(option.value),
      id: "id ".concat(option.label, " ").concat(option.value),
      value: option.value,
      variant: "outline-".concat(option.variant, " m-1"),
      checked: value === option.value
    }, option.label);
  })), isInvalid && /*#__PURE__*/_react.default.createElement("div", {
    className: "m-0 feedback"
  }, errors));
};

Toggle.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
  name: _propTypes.default.string.isRequired,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number,
    option: _propTypes.default.string,
    variant: _propTypes.default.oneOf(['info', 'primary', 'secondary', 'success', 'dark', 'danger', 'warning', 'light']),
    label: _propTypes.default.string,
    value: _propTypes.default.number
  })).isRequired,
  onChange: _propTypes.default.func.isRequired,
  type: _propTypes.default.string.isRequired,
  isInvalid: _propTypes.default.bool,
  errors: _propTypes.default.string,
  className: _propTypes.default.string,
  label: _propTypes.default.string
};
Toggle.defaultProps = {
  isInvalid: false,
  errors: '',
  className: '',
  label: ''
};
var _default = Toggle;
exports.default = _default;